import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useAuth } from '../auth';
import { toUserMessage } from '../api/client';
import { handleCallback } from '../auth/oauth';

type CallbackStatus = 'processing' | 'error';

export function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const theme = useTheme();
  const [status, setStatus] = useState<CallbackStatus>('processing');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      setErrorMessage(`Authorization denied: ${error}`);
      setStatus('error');
      return;
    }

    if (!code || !state) {
      setErrorMessage('Missing code or state parameter in callback URL.');
      setStatus('error');
      return;
    }

    let cancelled = false;

    handleCallback(code, state)
      .then((returnUrl) => {
        if (cancelled) return;
        return refreshAuth().then(() => navigate(returnUrl, { replace: true }));
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setErrorMessage(toUserMessage(err));
        setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate, refreshAuth]);

  if (status === 'error') {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 16,
          fontFamily: 'sans-serif',
        }}
      >
        <p role="alert" style={{ color: theme.colors.error.main, fontSize: 14 }}>{errorMessage}</p>
        <button
          onClick={() => {
            window.location.href = '/';
          }}
          style={{
            padding: '8px 16px',
            cursor: 'pointer',
            fontSize: 14,
          }}
        >
          Попробовать снова
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
        fontSize: 14,
        color: theme.colors.text.secondary,
      }}
    >
      Выполняется вход…
    </div>
  );
}
